import { render } from "./DashboardWidgetState.vue?vue&type=template&id=24a737ec&scoped=true"
import script from "./DashboardWidgetState.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetState.vue?vue&type=script&lang=js"

import "./DashboardWidgetState.vue?vue&type=style&index=0&id=24a737ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a737ec"]])

export default __exports__